module.exports = __webpack_public_path__ + "static/media/29BDOS26.fc948b0e.jpg";